// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader_loaderContainer__3yG8C {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  cursor: auto;\n}\n\n.loader_loader__QN6q0 {\n  height: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.loader_loader-container--black__360xy {\n  z-index: 80;\n  background: black;\n}", ""]);
// Exports
exports.locals = {
	"loaderContainer": "loader_loaderContainer__3yG8C",
	"loader": "loader_loader__QN6q0",
	"loader-container--black": "loader_loader-container--black__360xy"
};
module.exports = exports;
